module.exports = __webpack_public_path__ + "img/img_help_laef.25844407.svg";